var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "party",
    transform: "translate(0 -0.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104244",
    "data-name": "Group 104244",
    transform: "translate(5.135 1.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104243",
    "data-name": "Group 104243"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9438",
    "data-name": "Ellipse 9438",
    cx: 0.527,
    cy: 0.527,
    r: 0.527
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_104246",
    "data-name": "Group 104246",
    transform: "translate(9.236 3.241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104245",
    "data-name": "Group 104245"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9439",
    "data-name": "Ellipse 9439",
    cx: 0.527,
    cy: 0.527,
    r: 0.527
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_104248",
    "data-name": "Group 104248",
    transform: "translate(0 5.851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104247",
    "data-name": "Group 104247",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64128",
    "data-name": "Path 64128",
    d: "M3.615,170.028l-.943,2.039,3.745,3.745,2.039-.943ZM2.2,173.086.05,177.734a.528.528,0,0,0,.7.7l4.647-2.15Zm9.8-.638-5.964-5.964a.528.528,0,0,0-.852.151l-1.1,2.373L9.475,174.4l2.373-1.1A.527.527,0,0,0,12,172.448Z",
    transform: "translate(0 -166.329)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_104250",
    "data-name": "Group 104250",
    transform: "translate(6.317 0.631)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104249",
    "data-name": "Group 104249"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64129",
    "data-name": "Path 64129",
    d: "M180.207,22.461a1.581,1.581,0,0,1,0-2.237l.746-.746a.527.527,0,0,0,0-.746.527.527,0,1,1,.746-.746,1.581,1.581,0,0,1,0,2.237l-.746.746a.527.527,0,0,0,0,.746.527.527,0,1,1-.746.746Z",
    transform: "translate(-179.744 -17.834)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_104252",
    "data-name": "Group 104252",
    transform: "translate(15.574 11.815)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104251",
    "data-name": "Group 104251"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9440",
    "data-name": "Ellipse 9440",
    cx: 0.527,
    cy: 0.527,
    r: 0.527
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_104254",
    "data-name": "Group 104254",
    transform: "translate(13.71 7.714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104253",
    "data-name": "Group 104253"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9441",
    "data-name": "Ellipse 9441",
    cx: 0.527,
    cy: 0.527,
    r: 0.527
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_104256",
    "data-name": "Group 104256",
    transform: "translate(10.953 0.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104255",
    "data-name": "Group 104255",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64130",
    "data-name": "Path 64130",
    d: "M317.612,3.031c.431-.693.866-1.667.288-2.245s-1.55-.144-2.245.288c-.527-.628-1.3-1.335-2.031-.968s-.621,1.46-.431,2.223c-.78.312-1.673.851-1.546,1.648.059.374.4.978,1.978,1.085.06.887.343,1.99,1.235,1.99.716,0,1.206-.828,1.5-1.558.763.19,1.854.307,2.223-.431s-.341-1.505-.968-2.032Zm-1.949.737a.527.527,0,1,1,0-.745A.527.527,0,0,1,315.663,3.768Z",
    transform: "translate(-311.634 -0.005)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_104258",
    "data-name": "Group 104258",
    transform: "translate(12.591 9.269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104257",
    "data-name": "Group 104257"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64131",
    "data-name": "Path 64131",
    d: "M358.4,265.55a.527.527,0,0,1,.746-.746.528.528,0,0,0,.746,0l.746-.746a1.581,1.581,0,0,1,2.237,0,.527.527,0,0,1-.746.746.527.527,0,0,0-.746,0l-.746.746A1.583,1.583,0,0,1,358.4,265.55Z",
    transform: "translate(-358.247 -263.596)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_104260",
    "data-name": "Group 104260",
    transform: "translate(8.863 5.105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104259",
    "data-name": "Group 104259"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64132",
    "data-name": "Path 64132",
    d: "M252.335,147.5a.527.527,0,0,1,0-.746.528.528,0,0,0,0-.746.527.527,0,1,1,.746-.746,1.584,1.584,0,0,1,0,2.237A.527.527,0,0,1,252.335,147.5Z",
    transform: "translate(-252.181 -145.113)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_104262",
    "data-name": "Group 104262",
    transform: "translate(10.354 7.779)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104261",
    "data-name": "Group 104261"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64133",
    "data-name": "Path 64133",
    d: "M296.252,222.408a.527.527,0,0,0-.746,0,.527.527,0,1,1-.746-.746,1.583,1.583,0,0,1,2.237,0,.527.527,0,1,1-.746.746Z",
    transform: "translate(-294.606 -221.2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParty);
export default __webpack_public_path__ + "static/media/party.f893db09ff8ab1874ddd072c964b569f.svg";
export { ForwardRef as ReactComponent };